module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v(_vm._s(_vm.$t('noRecords')))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23492cf9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/affiliate/EmptyReminder.vue
// module id = 1279
// module chunks = 1